var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerNode"},[_c('div',{staticClass:"contentBox"},[_c('box-border',{attrs:{"title":`采办概览/技术评标状态 ( 共${_vm.MajorTrackOne.allDatas}个采办包 )`,"childBoxStyle":{
                display: 'flex'
            }}},[_c('echart-module',{ref:"MajorTrackOne",staticStyle:{"width":"50%"},attrs:{"option":_vm.MajorTrackOne}}),_c('echart-module',{ref:"MajorTrackTwo",staticStyle:{"width":"50%"},attrs:{"option":_vm.MajorTrackTwo}})],1),_c('box-border',{attrs:{"title":"采办分析","boxStyle":{
                'grid-row': '1 / span 3',
                'grid-column': '2 / span 1'
            }}},[_c('Table',_vm._b({attrs:{"tableStyle":{
                    height: '100%'
                },"tbodyStyle":{
                    'text-align': 'left'
                }}},'Table',_vm.PurchaseAnalysis,false))],1),_c('box-border',{attrs:{"title":"采办步骤跟踪"}},[_c('echart-module',{ref:"PurchaseStepsTrack",attrs:{"option":_vm.PurchaseStepsTrack}})],1),_c('box-border',{attrs:{"title":"采办步骤偏差"}},[_c('echart-module',{ref:"StepsVar",attrs:{"option":_vm.StepsVar}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }